import React from "react";
import { WorkPreparationRolesUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const RolesDropdown = ({
  resources,
  role,
  roles,
  onRoleChange,
  onRequestStart,
  onRequestEnd,
  containerClass,
  labelText = null,
  helperText = null,
  defaultValue = null,
  inputName = "role",
  id = "roles-dropdown",
  disabled = false,
  required = false,
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={labelText ?? resources["Role"]}
      value={role}
      placeholder={defaultValue ?? resources["DefaultDropdownValue"]}
      values={roles}
      handleChange={onRoleChange}
      inputName={inputName}
      addMarginBottom={true}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={WorkPreparationRolesUrl()}
      map={r => ({ key: r.id, name: r.description })}
      filter={r => r.isActive}
      sort={(a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase()))}
    />
  );
};

export default RolesDropdown;
